function createMarkup(content) {
  return { __html: content }
}

export default createMarkup
